<template>
  <v-alert :class="$style.reviewAlert">
    <div :class="$style.reviewWrapper">
      <div :class="$style.reviewContent">
        <div :class="$style.reviewIconBlock">
          <img src="@/assets/icons/clockYellowWarning.svg" alt="" />
        </div>
        <div :class="$style.reviewAlertInfoBlock">
          <h6 :class="$style.reviewTitle">Оставьте отзыв о работе подрядчика</h6>
          <p :class="$style.reviewText">
            Отзыв будет доступен в течении
            <strong>3-х дней</strong> с момента завершения заказа.
          </p>
        </div>
      </div>
      <v-btn
        color="primary"
        :large="$mq !== 'sm'"
        @click="isOpenFeedbackModal=true"
        :class="$style.sendReviewBtn"
      >
        Оставить отзыв
      </v-btn>
    </div>
    <FeedbackOrderModal
      :orderId="orderId"
      :isOpenFeedbackModal="isOpenFeedbackModal"
      @updateOrder="updateOrder"
      @close="handleCloseFeedbackModal"
    />
  </v-alert>
</template>

<script>

import FeedbackOrderModal from '@/components/FeedbackOrderModal/FeedbackOrderModal'

export default {
  components: {
    FeedbackOrderModal,
  },
  props: {
    orderId: Number,
  },
  emits: ['updateOrder'],
  data() {
    return {
      isOpenFeedbackModal: false,
    }
  },
  methods: {
    handleCloseFeedbackModal() {
      this.isOpenFeedbackModal = false
    },
    updateOrder() {
      this.$emit('updateOrder')
    },
  },
}
</script>

<style lang="scss" module>
.reviewWrapper{
  padding: 10px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  color: #222;
  @media (max-width: $mobileWidth) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 10px;
  }
}
.reviewIconBlock{
  margin: 6px 16px 0 0;
}
.reviewContent{
  display: flex;
}
.reviewTitle{
  font-size: 21px;
  font-weight: 700;
  @media (max-width: $mobileWidth) {
    font-size: 17px;
  }
}
.reviewText{
  font-size: 15px;
}
.reviewAlertInfoBlock{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media (max-width: $mobileWidth) {
  .sendReviewBtn{
    margin: 0 0 0 38px
  }
}
</style>
